import { FetchCaseMediaResponse } from '../services';
import { MainStore } from '..';
import { WritableDraft } from 'immer';

export const fetchCaseMediaSuccess = (
  state: WritableDraft<MainStore>,
  { payload }: { payload: FetchCaseMediaResponse }
) => {
  const {
    folder: {
      id: caseId,
      name: caseName,
      childTDOs: { records: tdos },
    },
  } = payload;

  const media = (tdos || []).filter((t) => {
    if (t?.details?.isExport === true) {
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment
    const softDeleteTimeTags = (t.details?.tags || []).filter(
      (t: any) => !!t.movedToTrashDateTime
    );
    return (softDeleteTimeTags?.length || 0) < 1;
  });

  return {
    ...state,
    caseMedia: {
      caseId,
      caseName,
      media,
    },
  };
};
